import { render, staticRenderFns } from "./CustomFieldListItem.vue?vue&type=template&id=55184d18&scoped=true&lang=pug&"
import script from "./CustomFieldListItem.vue?vue&type=script&lang=js&"
export * from "./CustomFieldListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55184d18",
  null
  
)

export default component.exports